import styled from '@emotion/styled/macro';

import { FormSelect } from '../../../../../../../components/UI/Form/FormSelect/FormSelect';

export const StyledFormSelect = styled(FormSelect)`
  max-width: 6.188rem;
  min-width: 6.188rem;
`;
